import type { SVGProps } from "react";
const SvgNumber01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    fillRule="evenodd"
    stroke="black"
    strokeWidth={0.501}
    strokeLinejoin="bevel"
    strokeMiterlimit={10}
    fontFamily="Times New Roman"
    fontSize={16}
    style={{
      fontVariantLigatures: "none",
    }}
    xmlnsXlink="http://www.w3.org/1999/xlink"
    xmlns="http://www.w3.org/2000/svg"
    overflow="visible"
    width="26.677pt"
    height="72.263pt"
    viewBox="41.784 -623.894 26.677 72.263"
    {...props}
  >
    <defs />
    <g id="Board Elements" transform="scale(1 -1)">
      <g
        id="Group"
        fillRule="nonzero"
        strokeLinejoin="round"
        strokeLinecap="round"
        stroke="none"
        strokeWidth={0.416}
      >
        <g id="Group_1">
          <g id="Group_2">
            <g id="Group_3" fill="#262626">
              <g id="Group_4">
                <path
                  d="M 49.656,618.819 C 50.075,619.068 50.538,619.226 51.046,619.293 L 64.56,621.081 C 64.877,621.123 65.146,621.046 65.366,620.849 C 65.585,620.652 65.685,620.391 65.663,620.065 L 66.283,554.686 C 66.261,554.36 66.154,554.072 65.962,553.82 C 65.769,553.569 65.514,553.422 65.197,553.38 L 52.063,551.642 C 51.746,551.6 51.478,551.678 51.258,551.875 C 51.038,552.072 50.939,552.333 50.96,552.659 L 50.505,603.631 C 50.463,603.948 50.315,604.09 50.062,604.056 L 43.165,602.757 C 42.467,602.664 42.103,602.971 42.074,603.678 L 41.785,613.904 C 41.765,614.547 42.059,615.005 42.668,615.28 L 49.656,618.819 Z"
                  markerStart="none"
                  markerEnd="none"
                />
              </g>
            </g>
            <g id="Group_5" fill="#f7e5c5">
              <g id="Group_6">
                <path
                  d="M 51.834,621.621 C 52.253,621.87 52.716,622.028 53.224,622.095 L 66.738,623.883 C 67.055,623.925 67.324,623.848 67.544,623.651 C 67.763,623.454 67.863,623.193 67.841,622.867 L 68.461,557.488 C 68.439,557.162 68.332,556.874 68.14,556.622 C 67.947,556.371 67.692,556.224 67.375,556.182 L 54.241,554.444 C 53.924,554.402 53.656,554.48 53.436,554.677 C 53.216,554.874 53.117,555.135 53.138,555.461 L 52.683,606.433 C 52.641,606.75 52.493,606.892 52.24,606.858 L 45.343,605.559 C 44.645,605.466 44.281,605.773 44.252,606.48 L 43.963,616.706 C 43.943,617.349 44.237,617.807 44.846,618.082 L 51.834,621.621 Z"
                  markerStart="none"
                  markerEnd="none"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);
export default SvgNumber01;
